module.exports = __webpack_public_path__ + "static/media/device.543bab07.png";